export default {
  NeedToCheckTicketsList: 'لیست تیکت های که نیاز به بررسی دارند',
  NeedToCheckAPITicketsList: 'لیست تیکت های تامین کننده که نیاز به بررسی دارند',
  Tickets: {
    Status: {
      New: 'جدید',
      Waiting: 'منتظر پاسخ',
      Pending: 'در حال بررسی',
      Answered: 'پاسخ داده شده',
      Close: 'بسته',
      CloseForever: 'بسته و قفل',
      Title: 'وضعیت تیکت',
      SystemicSuspension: 'معلق های سیستم',
    },
    Close: 'بستن تیکت',
    Pending: 'در حال بررسی',
    sendNotification: 'ارسال پیامک اطلاع رسانی',
    Modal: {
      Close: {
        Message: 'آیا برای بستن این تیکت مطمئن هستید؟',
      },
      Pending: {
        Message: 'آیا برای تغییر وضعیت به در حال بررسی این تیکت مطمئن هستید؟',
      },
    },
    Store: {
      Button: 'ایجاد تیکت برای کاربر',
      Modal: {
        Title: 'ایجاد تیکت برای کاربر',
        Form: {
          Input: {
            Title: 'عنوان تیکت',
            Content: 'متن تیکت',
          },
        },
      },
    },
    FailureCode: {
      Button: 'ثبت گزارش مشکل برای کاربر',
      Modal: {
        Title: 'ایجاد تیکت برای کاربر',
        Form: {
          Input: {
            ReasonMore: 'توضیح کوتاهی درباره مشکل وارد کنید.',
          },
        },
      },
      Reason: {
        Wrong: 'کد گیفت کارت اشتباه است.',
        Region: 'گیفت کارت ارور عدم مطابقت ریجن می دهد.',
        Used: 'گیفت کارت ارور استفاده شده می دهد.',
        Other: 'سایر',
      },
      sentReplaceCode: 'کد های جایگزین ارسال شده',
      MainCode: 'کد اصلی',
      RelatedCode: 'کد جایگزین',
      CreatedAtCode: 'تاریخ ورود به  مخزن',
      DeliveryAtCode: 'تاریخ تحویل',
    },
    Departments: {
      Support: 'پشتیبانی',
      Financial: 'مالی',
      Technical: 'فنی',
    },
    Report: {
      Button: 'گزارش پاسخ‌دهی',
      Chart: {
        Title: 'گزارش پاسخ‌دهی به تیکت‌ها',
        Minutes: 'دقیقه',
        Average: 'میانگین',
        Date: 'تاریخ',
        AverageTitle: 'میانگین به دقیقه',
        Count: 'تعداد',
        Number: 'عدد',
      },
      Admin: {
        Button: 'گزارش پاسخ‌دهی ادمین',
      },
      Total: 'کل',
    },
    CancelProduct: {
      Title: 'درخواست کنسلی‌ها',
      Count: 'تعداد کنسلی _COUNT_ عدد',
      ConfirmMessage: 'آیا این محصول از فاکتور کاربر کنسل شود؟',
      SuccessMessage: 'محصول از فاکتور کاربر حذف و پول به کیف پول کاربر برگشت داده شد.',
    },
    BillNumber: 'شماره فاکتور',
    CancelAndRefaund: 'کنسل کردن محصول و برگشت پول',
    Code: 'کد امنیتی را وارد کنید.',
    Folder: {
      Button: 'انتقال به پوشه',
      Title: 'انتقال تیکت به پوشه',
      FolderPlaceHolder: 'پوشه را انتخاب کنید.',
    },
    UnderMediation: 'پادرمیانی شده',
    NoMediation: 'بدون پادرمیانی',
    Mediation: 'درخواست پادرمیانی',
    ChangeApiGiftTicket: 'تغییر تیکت سرویس دهنده',
    NotFoundApiGiftTicket: 'تیکت توسط تامین کننده ثبت نشده است.',
  },
}
